import { WorkflowOrderFormFieldInputModel, WorkflowOrderInputModel } from '@ail/orders-api'
import './WorkflowOrderFormFieldsEdit.scss'

export function WorkflowOrderFormFieldsEdit(props: {
  order: WorkflowOrderInputModel
  onChange: (value: WorkflowOrderInputModel) => void
}) {
  const { order, onChange } = props

  const updateField = (fieldIdx: number, patch: Partial<WorkflowOrderFormFieldInputModel>) => {
    const updatedFields = order.form.fields.map((f, i) => (i === fieldIdx ? { ...f, ...patch } : f))
    onChange({ ...order, form: { ...order.form, fields: updatedFields } })
  }

  const addField = () => {
    const newField: WorkflowOrderFormFieldInputModel = {
      name: 'newField',
      bindingSource: '',
      type: 'Text',
      documents: [],
      tr: {},
      readonly: false,
      updateParent: false,
      notifyParent: false,
      notifyTenant: false,
      notifyParentTags: {},
      updateInternal: false,
      updateSuppliers: false,
    }
    onChange({ ...order, form: { ...order.form, fields: [...order.form.fields, newField] } })
  }

  const removeField = (fieldIdx: number) => {
    onChange({ ...order, form: { ...order.form, fields: order.form.fields.filter((_, i) => i !== fieldIdx) } })
  }

  const boolRow = (label: string, key: keyof WorkflowOrderFormFieldInputModel) => (
    <tr>
      <th className="row-header" scope="row">
        {label}
      </th>
      {order.form.fields.map((f, i) => (
        <td key={i} style={{ textAlign: 'center' }}>
          <input type="checkbox" checked={!!f[key]} onChange={() => updateField(i, { [key]: !f[key] })} />
        </td>
      ))}
    </tr>
  )

  return (
    <div className="workflow-order-form-fields-edit">
      <table className="workflow-order-form-fields-table" border={1}>
        <tbody>
          <tr>
            <th onClick={addField} style={{ cursor: 'pointer', color: 'green' }} className="row-header" scope="row">
              <i className="icon-add" />
            </th>
            {order.form.fields.map((_, i) => (
              <th
                onClick={() => removeField(i)}
                key={i}
                style={{ textAlign: 'center', cursor: 'pointer', color: 'red' }}
              >
                <i className="icon-close" />
              </th>
            ))}
          </tr>
          <tr>
            <th className="row-header" scope="row">
              Name
            </th>
            {order.form.fields.map((f, i) => (
              <td key={i} style={{ fontSize: 11 }}>
                <input type="text" value={f.name} onChange={(e) => updateField(i, { name: e.target.value })} />
              </td>
            ))}
          </tr>
          <tr>
            <th className="row-header" scope="row">
              Tr (en)
            </th>
            {order.form.fields.map((f, i) => (
              <td key={i} style={{ fontSize: 11 }}>
                <input
                  type="text"
                  value={f.tr?.en ?? ''}
                  onChange={(e) => updateField(i, { tr: { ...f.tr, en: e.target.value } })}
                />
              </td>
            ))}
          </tr>
          <tr>
            <th className="row-header" scope="row">
              Binding Source
            </th>
            {order.form.fields.map((f, i) => (
              <td key={i} style={{ fontSize: 11 }}>
                <input
                  type="text"
                  value={f.bindingSource}
                  onChange={(e) => updateField(i, { bindingSource: e.target.value })}
                />
              </td>
            ))}
          </tr>
          <tr>
            <th className="row-header" scope="row">
              Type
            </th>
            {order.form.fields.map((f, i) => (
              <td key={i} style={{ fontSize: 11 }}>
                <input type="text" value={f.type} onChange={(e) => updateField(i, { type: e.target.value })} />
              </td>
            ))}
          </tr>
          <tr>
            <th className="row-header" scope="row">
              Value
            </th>
            {order.form.fields.map((f, i) => (
              <td key={i} style={{ fontSize: 11 }}>
                <input
                  type="text"
                  value={f.value ?? ''}
                  onChange={(e) => updateField(i, { value: e.target.value || undefined })}
                />
              </td>
            ))}
          </tr>
          <tr>
            <th className="row-header" scope="row">
              Ext. DataSource
            </th>
            {order.form.fields.map((f, i) => (
              <td key={i} style={{ fontSize: 11 }}>
                <input
                  type="text"
                  value={f.externalDataSourceName ?? ''}
                  onChange={(e) => updateField(i, { externalDataSourceName: e.target.value || undefined })}
                />
              </td>
            ))}
          </tr>
          <tr>
            <th className="row-header" scope="row">
              Icon
            </th>
            {order.form.fields.map((f, i) => (
              <td key={i} style={{ fontSize: 11 }}>
                <input
                  type="text"
                  value={f.icon ?? ''}
                  onChange={(e) => updateField(i, { icon: e.target.value || undefined })}
                />
              </td>
            ))}
          </tr>
          {boolRow('Readonly', 'readonly')}
          {boolRow('Hidden', 'hidden')}
          {boolRow('Update Parent', 'updateParent')}
          {boolRow('Notify Parent', 'notifyParent')}
          {boolRow('Notify Tenant', 'notifyTenant')}
          {boolRow('Update Internal', 'updateInternal')}
          {boolRow('Update Suppliers', 'updateSuppliers')}
          {boolRow('Update Related Internal', 'updateRelatedInternal')}
          {boolRow('Update Related Suppliers', 'updateRelatedSuppliers')}
        </tbody>
      </table>
    </div>
  )
}
